import React, { useState, useEffect } from 'react';
import { ProductCard } from './ProductCard';
import { Button } from './ui/button';
import { productsAPI } from '../services/api';

export const ProductCatalog = ({ onAddToCart }) => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await productsAPI.getAll();
        setProducts(data);
      } catch (err) {
        console.error('Error loading products:', err);
        setError('Error al cargar productos');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
    const onSelect = (e) => setSelectedCategory(e.detail);
    window.addEventListener('selectCategory', onSelect);
    return () => window.removeEventListener('selectCategory', onSelect);
  }, []);

  const categories = ['Todos', ...new Set(products.map(p => p.category))];

  const filteredProducts = selectedCategory === 'Todos'
    ? products
    : products.filter(p => p.category === selectedCategory);

  if (loading) {
    return (
      <section id="productos" className="py-20 bg-gradient-to-b from-honey-50 to-white">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-honey-600"></div>
          <p className="mt-4 text-honey-900">Cargando productos...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="productos" className="py-20 bg-gradient-to-b from-honey-50 to-white">
        <div className="container mx-auto px-4 text-center">
          <p className="text-red-600">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section id="productos" className="py-20 bg-gradient-to-b from-honey-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-honey-950 mb-4">
            Nuestros productos
          </h2>
          <p className="text-lg text-honey-900/70 max-w-2xl mx-auto">
            Descubre nuestra línea completa de productos artesanales elaborados con miel orgánica 
            y ingredientes 100% naturales
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <Button
              key={category}
              variant={selectedCategory === category ? 'default' : 'outline'}
              onClick={() => setSelectedCategory(category)}
              className={
                selectedCategory === category
                  ? 'bg-honey-600 hover:bg-honey-700 text-white'
                  : 'border-honey-300 text-honey-900 hover:bg-honey-50 hover:border-honey-400'
              }
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={onAddToCart}
            />
          ))}
        </div>

        {/* No products message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <p className="text-honey-900/70">No hay productos en esta categoría</p>
          </div>
        )}
      </div>
    </section>
  );
};
